import api from '../api'

const baseUrl = '/academy/api/AdminCourse'
const baseUrlPackage = '/academy/api/AdminPackage'

const skillUpFrequentlyAskedQuestionsProvider = {
  getQuestions(id) {
    return api.get(`${baseUrl}/FrequentlyAskedQuestions/${id}`)
  },

  addFrequentlyAskedQuestions(params) {
    return api.post(`${baseUrl}/FrequentlyAskedQuestions`, params)
  },
  getPackageQuestions(id) {
    return api.get(`${baseUrlPackage}/FrequentlyAskedQuestions/${id}`)
  },

  addPackageFrequentlyAskedQuestions(params) {
    return api.post(`${baseUrlPackage}/FrequentlyAskedQuestions`, params)
  },
}

export default skillUpFrequentlyAskedQuestionsProvider
